var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceNow2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Integrations/Service Now@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Integrations/Service-Now",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#D8DDE4",
    opacity: 0.188313802,
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "NOW",
    transform: "translate(6, 7)",
    fill: "#62D84E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2180606,1.87616593 C19.0297672,3.08126058 20.4278101,4.78113538 21.2327014,6.75890039 C22.038995,8.73530983 22.2142762,10.9001424 21.7375113,12.9741523 C21.2607464,15.0481622 20.1543714,16.9378157 18.5586113,18.4004672 C18.3721121,18.5753347 18.1547634,18.7176687 17.9163809,18.8179803 C17.6779985,18.9196474 17.4227891,18.9792921 17.1633729,18.9928478 C16.9039567,19.0077589 16.6431382,18.9779366 16.3949401,18.9033807 C16.1467419,18.8301803 15.9139684,18.7149575 15.7064355,18.561779 C15.0305511,18.0751323 14.2789453,17.6969305 13.479663,17.4420848 C12.6789784,17.1858836 11.8432376,17.0557496 11.0004856,17.0557496 C10.1577335,17.0557496 9.32059046,17.1858836 8.52130815,17.4420848 C7.72202584,17.6969305 6.96901777,18.0751323 6.29313342,18.561779 C6.08840497,18.713602 5.85843603,18.8301803 5.61164008,18.9047362 C5.36484414,18.9792921 5.1068302,19.0104701 4.84881626,18.9969144 C4.59080232,18.9847144 4.33699513,18.9277808 4.10001494,18.8288248 C3.86303475,18.7298687 3.64568605,18.5916014 3.45778459,18.419445 C1.85080647,16.9513713 0.73601798,15.0508734 0.259253092,12.9633078 C-0.217511796,10.8757423 -0.0338170891,8.69870966 0.786498968,6.71416684 C1.60681503,4.72826846 3.02448944,3.0270381 4.85722976,1.83007682 C6.68997008,0.633115545 8.85223907,-0.00535417345 11.0649891,3.382254e-05 C13.2637165,0.0176903812 15.406354,0.672426845 17.2180606,1.87616593 Z M13.1262961,15.621565 C13.8021804,15.3612971 14.4163658,14.9708952 14.9309914,14.4747595 C15.445617,13.9772682 15.8494649,13.3848876 16.1186969,12.7315067 C16.3879288,12.0794814 16.5169358,11.3800114 16.4973043,10.6778302 C16.4973043,9.26940128 15.9181752,7.91926149 14.8875217,6.92292339 C13.8568681,5.9265853 12.4588252,5.36673817 11.0004856,5.36673817 C9.54214591,5.36673817 8.14410299,5.9265853 7.11344948,6.92292339 C6.08279597,7.91926149 5.50366686,9.26940128 5.50366686,10.6778302 C5.48403536,11.3800114 5.61304233,12.0794814 5.88227427,12.7315067 C6.15150621,13.3848876 6.55535411,13.9772682 7.06997974,14.4747595 C7.58460537,14.9708952 8.19879073,15.3612971 8.87327282,15.621565 C9.54915716,15.8818329 10.272718,16.0065446 11.0004856,15.9875667 C11.7268509,16.0065446 12.4504117,15.8818329 13.1262961,15.621565 L13.1262961,15.621565 Z",
    id: "Layer"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceNow2X);
export default __webpack_public_path__ + "static/media/Service Now@2x.ac656ecd70ff94476c8aaf045182cadc.svg";
export { ForwardRef as ReactComponent };